<template>
  <div class="search-container" aria-label="全站搜索结果页面">
    <div class="wrap-header"></div>
    <div class="search-main">
      <!-- 标题区域 -->
      <div class="search-header">
        <h1 class="search-title">
          搜索结果
          <span v-if="searchKey" class="highlight-key">“{{ searchKey }}”</span>
          <span v-else class="empty-key">请输入关键词</span>
        </h1>
        <div class="result-count" v-if="resultList.length">
          共 {{ resultList.length }} 条相关结果
        </div>
      </div>

      <!-- 无结果状态 -->
      <div class="empty-box" v-if="resultList.length === 0 && searchKey" role="status">
        <div class="empty-icon">
          <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="#ccc" stroke-width="1.5" aria-hidden="true">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </div>
        <p class="empty-text">未找到相关产品 / 页面</p>
        <p class="empty-hint">请尝试更换关键词重新搜索，可搜索医学影像实训设备、虚拟仿真教学系统、VR医学实训平台等内容</p>
      </div>

      <!-- 搜索结果列表 -->
      <div class="result-list" v-else>
        <div
          class="result-item"
          v-for="(item, index) in resultList"
          :key="item.path"
          @click="$router.push(item.path)"
          :style="{ animationDelay: `${index * 0.05}s` }"
          role="link"
          tabindex="0"
          @keydown.enter="$router.push(item.path)"
          :aria-label="`查看详情：${item.title}`"
        >
          <div class="item-index">{{ String(index + 1).padStart(2, '0') }}</div>
          <div class="item-content">
            <h2 class="item-title" v-html="safeHighlight(item.title)"></h2>
            <p class="item-desc" v-html="safeHighlight(item.text)"></p>
          </div>
          <div class="item-arrow" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 全站搜索数据源 —— 与路由一一对应
const siteAllData = [
  { path: '/', title: '首页', desc: '官网、首页、企业、介绍', text: '医影智能官网首页' },
  { path: '/about', title: '关于我们', desc: '公司、简介、发展历程、企业、文化、我们', text: '公司介绍、合作市场、资质展示' },
  //   { path: '/product', title: '医影产品-软件产品', desc: '全系医学影像教学软件产品汇总' },
  //   { path: '/hardware', title: '医影产品-硬件产品', desc: 'CT/DR/MRI实训硬件设备' },
  { path: '/news', title: '新闻资讯', desc: '企业动态、行业新闻、展会资讯', text: '公司新闻、行业资讯' },
  // { path: '/co', title: '合作院校', desc: '全国合作医学院校展示', text: '医影智能官网首页' },
  { path: '/people', title: '人才招聘', desc: '公司、招聘、岗位、福利、待遇、工作、加入', text: '工作环境、员工福利、人才招聘' },
  { path: '/contact', title: '联系我们', desc: '地址、电话、在线咨询、联系我们、商务合作、联系电话、公司地址', text: '联系我们、商务合作、联系电话、公司地址' },
  { path: '/medical', title: '医影产品总览', desc: '软件、硬件、产品、分类', text: '软件产品、硬件产品' },
  { path: '/vr', title: '医学影像中心VR系统', desc: '影像、VR、虚拟、实训、系统、软件、医学', text: '医学影像中心VR系统' },
  { path: '/deviceCT', title: 'CT设备结构虚拟仿真系统', desc: 'CT、设备、结构、影像、虚拟、实训、系统、软件、仿真', text: '设备结构虚拟仿真系统' },
  { path: '/deviceDR', title: 'DR设备结构虚拟仿真系统', desc: 'DR、设备、结构、影像、虚拟、实训、系统、软件、仿真', text: '设备结构虚拟仿真系统' },
  { path: '/deviceMRI', title: 'MRI设备结构虚拟仿真系统', desc: 'MRI、设备、结构、影像、虚拟、实训、系统、软件、仿真', text: '设备结构虚拟仿真系统' },
  { path: '/perCT', title: 'CT性能检测虚拟仿真系统', desc: 'CT、性能、检测、影像、虚拟、实训、系统、软件、仿真', text: '性能检测虚拟仿真系统' },
  { path: '/perDR', title: 'DR性能检测虚拟仿真系统', desc: 'DR、性能、检测、影像、虚拟、实训、系统、软件、仿真', text: '性能检测虚拟仿真系统' },
  { path: '/perMRI', title: 'MRI性能检测虚拟仿真系统', desc: 'MRI、性能、检测、影像、虚拟、实训、系统、软件、仿真', text: '性能检测虚拟仿真系统' },
  { path: '/checkCT', title: 'CT检查技术虚拟仿真系统', desc: 'CT、检查、技术、影像、虚拟、实训、系统、软件、仿真', text: '检查技术虚拟仿真系统' },
  { path: '/checkDR', title: 'DR检查技术虚拟仿真系统', desc: 'DR、检查、技术、影像、虚拟、实训、系统、软件、仿真', text: '检查技术虚拟仿真系统' },
  { path: '/checkMRI', title: 'MRI检查技术虚拟仿真系统', desc: 'MRI、检查、技术、影像、虚拟、实训、系统、软件、仿真', text: '检查技术虚拟仿真系统' },
  { path: '/CT', title: 'CT教学实训设备', desc: 'CT、教学、实训、硬件、设备、硬件', text: '教学实训设备' },
  { path: '/DR', title: 'DR教学实训设备', desc: 'DR、教学、实训、硬件、设备、硬件', text: '教学实训设备' },
  { path: '/MRI', title: 'MRI教学实训设备', desc: 'MRI、教学、实训、硬件、设备、硬件、医学', text: '教学实训设备' },
  { path: '/pacs', title: '医学影像诊断思维教学系统', desc: '影像、教学、系统、诊断、思维、软件、医学', text: '医学影像诊断思维教学系统' },
  { path: '/course', title: '医学影像处理教学系统', desc: '影像、处理、图像、教学、系统、软件、医学' , text: '医学影像处理教学系统'},
  { path: '/dissect', title: '医学影像解剖图谱', desc: '影像、图像、解剖、图谱、教学、系统、软件、医学', text: '医学影像解剖图谱' },
  { path: '/handle', title: '三维影像后处理系统', desc: '影像、处理、系统、三维、硬件', text: '三维影像后处理系统详情页' },
  { path: '/supersound', title: '超声教学实训设备', desc: '超声、设备、教学、实训、硬件', text: '超声教学实训设备详情页' },
  { path: '/dieBody', title: '医学人体模型 X线、CT、MRI', desc: '医学、人体、模型、X线、CT、MRI、硬件', text: '医学人体模型 X线、CT、MRI' },
  { path: '/dieBodyUS', title: '医学人体模型 X线、CT、超声', desc: '医学、人体、模型、X线、CT、超声、硬件', text: '医学人体模型 X线、CT、超声' },
  { path: '/equipment', title: '设备结构虚拟仿真系统', desc: 'CT、DR、MRI、设备、结构、虚拟、系统、软件、仿真', text: '设备结构虚拟仿真系统' },
  { path: '/performance', title: '性能检测虚拟仿真系统', desc: 'CT、DR、MRI、性能、检测、虚拟、系统、软件、仿真', text: '性能检测虚拟仿真系统' },
  { path: '/check', title: '检查技术虚拟仿真系统', desc: 'CT、DR、MRI、检查、虚拟、系统、软件、仿真', text: '检查技术虚拟仿真系统' },
  { path: '/model', title: '医学人体模型', desc: '医学、人体、模型、X线、CT、MRI、超声、硬件', text: '医学人体模型' },
  { path: '/teaching', title: '教学实训设备', desc: 'CT、DR、MRI、教学、实训、设备、硬件', text: '教学实训设备' },
]

export default {
  name: 'SearchResult',
  data() {
    return {
      searchKey: '',
      resultList: [],
    }
  },
  mounted() {
    this.getSearchResult()
  },
  // 路由参数改变，组件不销毁时强制刷新搜索（解决换关键词列表不变）
  beforeRouteUpdate(to, from, next) {
    this.getSearchResult()
    next()
  },
  watch: {
    '$route.query.key': {
      handler() {
        this.getSearchResult()
      },
      deep: true
    }
  },
  methods: {
    /**
     * 模糊匹配规则：连续2字符即可命中
     * 例：搜索「发展」可匹配「发展历程」
     */
    fuzzyMatch(sourceText, searchText) {
      const source = sourceText.toLowerCase()
      const keyword = searchText.toLowerCase()
      if (!keyword) return false
      // 单字符直接包含匹配
      if (keyword.length === 1) return source.includes(keyword)
      // 1. 文本完整包含关键词，直接命中
      if (source.includes(keyword)) return true
      // 2. 截取关键词所有连续二元片段，文本任意一处包含即匹配
      const twoCharList = []
      for (let i = 0; i <= keyword.length - 2; i++) {
        twoCharList.push(keyword.slice(i, i + 2))
      }
      return twoCharList.some(sub => source.includes(sub))
    },

    getSearchResult() {
      // 获取路由关键词，并清除全部空格
      const rawKey = this.$route.query.key || ''
      this.searchKey = rawKey.trim()
      const key = rawKey.replace(/\s/g, '').trim()
      // 动态修改页面title，利于SEO
      if(this.searchKey){
        document.title = `${this.searchKey} - 搜索结果 | 医影智能-医学影像虚拟仿真实训设备厂家`
      }else{
        document.title = `站内搜索 | 医影智能-医学影像虚拟仿真实训设备厂家`
      }
      // 无关键词清空列表
      if (!key) {
        this.resultList = []
        return
      }
      // 仅匹配 desc，title / text 不再参与检索
      let list = siteAllData.filter(item => {
        return this.fuzzyMatch(item.desc, key)
      })
      // 排序：仅判断desc完全包含关键词的条目置顶
      list.sort((a, b) => {
        const k = key.toLowerCase()
        const aFullMatch = a.desc.toLowerCase().includes(k)
        const bFullMatch = b.desc.toLowerCase().includes(k)
        if (aFullMatch && !bFullMatch) return -1
        if (!aFullMatch && bFullMatch) return 1
        return 0
      })
      this.resultList = list
    },

    // XSS防御：先转义原始文本，再添加高亮标签（SEO安全，防止注入）
    safeHtmlEscape(str) {
      if(!str) return ''
      return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },

    // 关键词高亮（增加XSS防护，优化爬虫抓取）
    safeHighlight(text) {
      if (!this.searchKey || !text) return this.safeHtmlEscape(text)
      const safeText = this.safeHtmlEscape(text)
      const safeKey = this.safeHtmlEscape(this.searchKey)
      const reg = new RegExp(safeKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
      return safeText.replace(reg, '<span class="highlight-text">$&</span>')
    },
  },
}
</script>

<style lang="scss" scoped>
.search-container {
  min-height: 100vh;
  background: linear-gradient(145deg, #f0f4fb 0%, #e8eef6 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.wrap-header {
  height: 80px;
}

.search-main {
  max-width: 820px;
  margin: 0 auto;
  padding: 0 24px 80px;
}

/* ===== 头部区域 ===== */
.search-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
  margin-bottom: 36px;
  padding-bottom: 16px;
  border-bottom: 2px solid rgba(37, 99, 175, 0.12);
}

.search-title {
  font-size: 26px;
  font-weight: 600;
  color: #0b1e33;
  margin: 0;
  letter-spacing: -0.3px;
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;

  .highlight-key {
    color: #2563af;
    background: rgba(37, 99, 175, 0.10);
    padding: 0 12px;
    border-radius: 30px;
    font-weight: 600;
    font-size: 22px;
  }

  .empty-key {
    color: #999;
    font-weight: 400;
    font-size: 20px;
  }
}

.result-count {
  font-size: 14px;
  color: #5a6f8c;
  background: #fff;
  padding: 4px 16px;
  border-radius: 30px;
  font-weight: 500;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

/* ===== 空状态 ===== */
.empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px 60px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);
  margin-top: 20px;

  .empty-icon {
    margin-bottom: 20px;
    opacity: 0.5;
  }

  .empty-text {
    font-size: 20px;
    font-weight: 500;
    color: #1a2b3e;
    margin: 0 0 6px;
  }

  .empty-hint {
    font-size: 15px;
    color: #8a9bb0;
    margin: 0;
  }
}

/* ===== 结果列表 ===== */
.result-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.result-item {
  display: flex;
  align-items: stretch;
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #eef3f9;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.2, 0, 0, 1);
  animation: fadeSlideUp 0.4s ease both;
  gap: 16px;
  outline: none;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(37, 99, 175, 0.10);
    border-color: #b6d4f0;
    background: #fafdff;

    .item-arrow {
      opacity: 1;
      transform: translateX(2px);
    }
  }
  &:focus-visible{
    box-shadow: 0 0 0 3px rgba(37, 99, 175, 0.25);
  }

  .item-index {
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 600;
    color: #b0c6dd;
    letter-spacing: 0.5px;
    padding-top: 2px;
    min-width: 32px;
  }

  .item-content {
    flex: 1;
    min-width: 0;
  }

  .item-title {
    font-size: 18px;
    font-weight: 600;
    color: #0b1e33;
    margin: 0 0 6px;
    line-height: 1.4;
    letter-spacing: -0.2px;
  }

  .item-desc {
    font-size: 14px;
    color: #4a5f78;
    margin: 0 0 8px;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-meta {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .item-path {
    font-size: 12px;
    color: #8ba0b9;
    background: #f0f5fc;
    padding: 2px 12px;
    border-radius: 20px;
    font-weight: 500;
    letter-spacing: 0.2px;
    font-family: 'SF Mono', 'Fira Code', monospace;
  }

  .item-arrow {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    color: #2563af;
    opacity: 0.3;
    transition: all 0.2s;
    margin-left: 4px;
  }
}

/* ===== 动画 ===== */
@keyframes fadeSlideUp {
  0% {
    opacity: 0;
    transform: translateY(16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 搜索关键词高亮补充样式 */
.highlight-text {
  color: #2563af;
  font-weight: 600;
  background: rgba(37, 99, 175, 0.1);
  padding: 0 2px;
  border-radius: 2px;
}

/* ===== 响应式 ===== */
@media (max-width: 640px) {
  .wrap-header {
    height: 60px;
  }

  .search-main {
    padding: 0 16px 60px;
  }

  .search-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .search-title {
    font-size: 22px;

    .highlight-key {
      font-size: 18px;
    }
  }

  .result-item {
    padding: 16px 18px;
    flex-wrap: wrap;

    .item-index {
      display: none;
    }

    .item-title {
      font-size: 16px;
    }

    .item-arrow {
      display: none;
    }
  }

  .empty-box {
    padding: 50px 16px;
  }
}
</style>